// src/components/ui/calendar/day/DayViewHeader/DayViewHeaderShadcn.jsx
import React from 'react';
import { cn } from '../../../../../utils/cn';
import { CalendarDateHeaderShadcn } from '../../core';

const DayViewHeaderShadcn = ({
  currentDate,
  className = ''
}) => {
  const today = new Date();
  const isToday = currentDate.toDateString() === today.toDateString();

  return (
    <div className={cn(
      // Header styling for day view + normalized height
      "flex items-center justify-center bg-slate-800/40 border-b border-slate-600/30 p-2 h-12",
      className
    )}>
      <CalendarDateHeaderShadcn
        date={currentDate}
        view="day"
        isToday={isToday}
        showWeekday={true}
      />
    </div>
  );
};

export default DayViewHeaderShadcn;